import type { FAQ } from './types';

export const faqs: FAQ[] = [
  {
    question: '《色戒》无删减版与删减版的主要区别是什么？',
    answer: '《色戒》无删减版（完整版）片长为157分钟，删减版约为144分钟，两者相差约13分钟。主要删减内容集中在三场关键情感戏及部分心理描写的细节镜头。无删减版保留了李安导演完整的艺术表达，人物情感转折更加流畅自然，是理解影片完整内涵的最佳版本。',
  },
  {
    question: '在哪里可以观看《色戒》无删减版高清完整版？',
    answer: '目前可通过以下正版渠道观看《色戒》无删减版：1）购买海外发行的蓝光收藏版（含完整157分钟内容及幕后花絮）；2）通过Criterion Channel等国际流媒体平台订阅观看；3）在iTunes Store、Google Play Movies等数字商店购买或租赁。建议选择正版渠道以获得最佳观影体验。',
  },
  {
    question: '《色戒》无删减版值得看吗？删减是否影响理解？',
    answer: '对于希望完整理解李安导演艺术表达的影迷来说，无删减版绝对值得一看。删减版虽然保留了主要剧情线，但被删减的内容包含了重要的人物心理变化细节。缺少这些内容，王佳芝最终选择放走易先生的情感动机可能显得不够充分，整部电影的情感张力也会有所减弱。',
  },
  {
    question: '李安为什么要拍《色戒》？电影的创作背景是什么？',
    answer: '李安在读完张爱玲的同名短篇小说后被深深震撼，他认为这是一个关于"爱情、背叛与人性"的永恒故事。影片创作历时数年，李安投入了大量精力研究1940年代上海的历史资料。他曾表示《色戒》是他创作生涯中最艰难的一部作品。电影改编自张爱玲晚年创作的短篇小说，小说的创作灵感据信与她本人与胡兰成的情感经历有关。',
  },
  {
    question: '《色戒》获得了哪些重要奖项？',
    answer: '《色戒》在第64届威尼斯国际电影节上斩获最高荣誉——金狮奖，这是李安三年内第二次获得该奖项。在第44届金马奖上，影片获得最佳影片、最佳导演、最佳男主角（梁朝伟）、最佳新人（汤唯）等七项大奖。此外，影片还被多家国际媒体评为"21世纪最重要的亚洲电影之一"。',
  },
  {
    question: '《色戒》的演员阵容有哪些？他们的表现如何？',
    answer: '《色戒》由梁朝伟饰演易先生，汤唯饰演王佳芝，王力宏饰演邝裕民，陈冲饰演易太太。梁朝伟凭借此片获得金马奖最佳男主角，汤唯作为新人获得了极高评价和金马奖最佳新人奖。李安导演对演员的精湛指导使得每个角色都极具层次感和说服力。',
  },
];